export type DataLayerItem = Record<string, unknown>;

declare global {
  interface Window {
    dataLayer: DataLayerItem[];
  }
}

function ensureDL() {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
}

export function dlPushRaw(item: DataLayerItem) {
  if (typeof window === "undefined") return;
  ensureDL();
  window.dataLayer.push(item);
}

export function dlPushEvent(event: string, params?: DataLayerItem) {
  if (typeof window === "undefined") return;
  ensureDL();
  window.dataLayer.push({ event, ...(params || {}) });
}

export function initGTM(containerId: string) {
  if (!containerId || typeof document === "undefined") return;

  const TAG_ID = "gtm-script";
  if (document.getElementById(TAG_ID)) return;

  ensureDL();

  dlPushEvent("gtm.js", { "gtm.start": Date.now() });
  dlPushEvent("default_consent");
  dlPushEvent("consent_update", { consent_update_reason: "default" });

  const script = document.createElement("script");
  script.id = TAG_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
  document.head.appendChild(script);
}

export function GTMNoScript({ containerId }: { containerId: string }) {
  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${containerId}`}
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
        title="gtm"
      />
    </noscript>
  );
}

export function clearEcommerce() {
  dlPushRaw({ ecommerce: null });
}
export function clearError() {
  dlPushRaw({ error: null });
}

export function resetDlState() {
  dlPushRaw({ ecommerce: null, error: null });
}
